import { create } from "zustand";

interface AddContactStore {
    isOpen: boolean;
    open: () => void;
    close: () => void;
}

const useAddContactModal = create<AddContactStore>((set) => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false })
}));

export default useAddContactModal;